import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=e5fd4f72"
import script from "./SelectCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCourse.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5fd4f72')) {
      api.createRecord('e5fd4f72', component.options)
    } else {
      api.reload('e5fd4f72', component.options)
    }
    module.hot.accept("./SelectCourse.vue?vue&type=template&id=e5fd4f72", function () {
      api.rerender('e5fd4f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/course/course/components/SelectCourse.vue"
export default component.exports